<script>
import { produitsAjoutesPanierProps } from "./mixin";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import StickyFooter from "@/components/molecules/sticky-footer";
import Titre from "@/components/atoms/titre";

export default {
  name: "ProduitsAjoutesPanierMobile",
  components: {
    Badge,
    Icon,
    Divider,
    List,
    ListItem,
    LazyImage,
    Button,
    StickyFooter,
    Titre
  },
  props: {
    ...produitsAjoutesPanierProps()
  },
  emits: ["showSimilaires", "close", "open_encart_panier"]
};
</script>

<template>
  <div class="c-produits-ajoutes-panier-mobile u-text-center u-flex u-flex-column u-full-height">
    <div class="u-pl-sm u-pr-sm">
      <Badge
        circle
        variant="season"
        size="xlg"
        class="u-mr-sm u-mb-xs u-text-center"
      >
        <Icon
          name="check"
          variant="white"
        />
      </Badge>

      <Titre
        tag="h1"
        size="sm"
        class="u-mb-md u-text-center"
      >
        Produits ajoutés au panier
      </Titre>

      <Divider
        dotted
        class="u-mt-md u-mb-md"
      />

      <template v-if="articlesIndisponibles && articlesIndisponibles.length > 0">
        <Titre
          tag="h2"
          size="xs"
          class="u-mb-xs u-text-left"
        >
          <template v-if="articlesIndisponibles.length > 1">
            {{ articlesIndisponibles.length }} produits sont indisponibles
          </template>
          <template v-else>
            {{ articlesIndisponibles.length }} produit est indisponible
          </template>
        </Titre>
        <div class="u-flex u-mb-sm u-text-left u-font-15">
          <Icon
            name="alert-circle-outline"
            variant="primary"
            class="u-mr-xs"
            size="sm"
          />
          <p class="u-color-grey-1 u-font-14">
            Ces produits sont indisponibles actuellement.
            <br>
            Ils seront retirés de votre commande.
          </p>
        </div>
        <List class="c-produits-ajoutes-panier__list">
          <ListItem
            v-for="article in articlesIndisponibles"
            :key="article.id"
            class="c-produits-ajoutes-panier-mobile__list"
          >
            <div class="u-flex u-flex-align-center">
              <LazyImage
                :src="article.visuel"
                width="50"
                height="50"
                :dimension="140"
              />
              <p class="u-ml-sm u-mr-sm u-font-15">
                {{ article.designation }}
              </p>
            </div>
            <div class="u-text-right">
              <Button
                variant="primary"
                radius="full"
                size="xs"
                @click="$emit('showSimilaires', article)"
              >
                Voir les produits similaires
              </Button>
            </div>
          </ListItem>
        </List>
      </template>
    </div>
    <StickyFooter
      v-if="articlesIndisponibles && articlesIndisponibles.length > 0"
      :in-dom="false"
      class="u-text-center"
    >
      <div class="u-inline-flex">
        <Button
          outline
          variant="primary"
          size="md"
          radius="full"
          class="u-mr-md"
          @click="$emit('close')"
        >
          Ignorer
        </Button>
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-ml-md"
          @click="$emit('open_encart_panier')"
        >
          Voir mon panier
        </Button>
      </div>
    </StickyFooter>
    <div
      v-else
      class="u-text-center u-mt-xlg"
    >
      <Button
        variant="secondary"
        size="md"
        radius="full"
        class="u-mb-md"
        @click="$emit('open_encart_panier')"
      >
        Voir mon panier
      </Button>
      <br>
      <Button
        outline
        variant="primary"
        size="md"
        radius="full"
        @click="$emit('close')"
      >
        Je continue mes courses
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-produits-ajoutes-panier-mobile__list {
  padding-bottom: spacing(md);
  padding-top: spacing(md);
  border-bottom: 1px solid color(grey-4);
  &:last-child {
    border-bottom: none;
  }
}
</style>
